module.exports = __webpack_public_path__ + "static/img/ikonaCwiczenieDisabled-ON.2c6fd99f.png";